import { render, staticRenderFns } from "./v-notification.vue?vue&type=template&id=44b56316"
import script from "./v-notification.vue?vue&type=script&lang=js"
export * from "./v-notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44b56316')) {
      api.createRecord('44b56316', component.options)
    } else {
      api.reload('44b56316', component.options)
    }
    module.hot.accept("./v-notification.vue?vue&type=template&id=44b56316", function () {
      api.rerender('44b56316', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/notification/v-notification.vue"
export default component.exports